import { Mark, mergeAttributes } from '@tiptap/core';

// CharMark — wraps a span of text as a screenplay character cue. The mark
// round-trips through markdown as `<char>NAME</char>` (or
// `<char init="chapterId">NAME</char>` for the first appearance) via
// tiptapMarkdown.js. Text inside the mark stays plain — no literal `<` `>`
// chars in the document, so the caret can't accidentally land inside the
// wrapper.
//
// The `init` attribute tags the chapter where the character was first
// introduced. The screenplay-decoupage pipeline reads this to track per-
// scene character appearances; subsequent mentions don't carry init.
const CharMark = Mark.create({
  name: 'char',

  // Once the user types past the character name we want their next keystroke
  // to escape the mark, not extend it.
  inclusive: false,

  addAttributes() {
    return {
      init: {
        default: null,
        parseHTML: (el) => el.getAttribute('init') || null,
        renderHTML: (attrs) => (attrs.init ? { init: attrs.init } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'char' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['char', mergeAttributes(HTMLAttributes), 0];
  },
});

export default CharMark;
